export const replaceAt = (string, index, replacement) =>
  string.substr(0, index) +
  replacement +
  string.substr(index + replacement.length);

export const replaceFromTo = (string, start, end, replacement) => {
  let newString = string;
  for (let index = start; index < end; index++) {
    newString = replaceAt(newString, index, replacement);
  }
  return newString;
};

export const deleteByCharacter = (string, val) => {
  const index = string.indexOf(val);
  return index !== -1
    ? string.substr(0, index) + string.substr(index + 1, string.length)
    : string;
};

export const numberToDay = (index) =>
  ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"][
    index
  ];

export const removeAccents = (str) => {
  const strNoAccents = str.split("");

  strNoAccents.forEach((char, index) => {
    switch (char) {
      case "á":
        strNoAccents[index] = "a";
        break;
      case "é":
        strNoAccents[index] = "e";
        break;
      case "í":
        strNoAccents[index] = "i";
        break;
      case "ó":
        strNoAccents[index] = "o";
        break;
      case "ú":
        strNoAccents[index] = "u";
        break;

      default:
        break;
    }
  });

  return strNoAccents.join("");
};
